import React from 'react'

import Layout from '../layout/layout'
import Seo from "../layout/seo"
import { StaticImage } from 'gatsby-plugin-image';
import imgHeroLogo from "../images/ignite-summit-icon-turquoise.svg"

import './styles/training.scss';


const training = ({data}) => {
    
    
    
    return (
        <Layout attr="training" >
            <Seo title="Free Developer Training" />
            <div className="innerHeader">
                <div className="container">
                    <img src={imgHeroLogo} width={`57px`} height={`40px`} />
                    <h1>Pre-conference <span className="turquoise">Developer Training</span><span className='date'>Free • 24 February</span></h1>
                </div>
            </div>
            <div className="container header-content" >
                <p>Pre-conference developer training sessions are led by GridGain consultants and solution architects with deep technical expertise and practical experience. During these sessions, you’ll use real products to discover the full potential of the Ignite platform.</p>
                <p>After completing the training, you’ll receive a special badge to showcase your Apache Ignite skills to peers and potential employers.</p>
                <p className="toc">Click the links below to join a future training session.</p>
                <ul>
                    <li><a href="#apache-ignite-essentials">Apache Ignite Essentials: Design Principles for Building Data-Intensive Applications (EU)</a></li>
                    <li><a href="#apache-ignite-spring-boot">Apache Ignite for Spring Boot and Spring Data Development</a></li>
                    <li><a href="#apache-ignite-design-principles">Apache Ignite Essentials: Design Principles for Building Data-Intensive Applications (US)</a></li>
                </ul>

            </div>
                <div className="training-members">

                    <article className="training-session" id="apache-ignite-essentials" >
                        <div className="container" >
                            <header>
                                <div className="txt-wrapper">
                                    <h2>Apache Ignite Essentials: Design Principles for Building Data-Intensive Applications</h2>
                                    <h4>Feb. 24 14:00 PM GMT / 9:00  AM EST</h4>
                                </div>
                            </header>
                            <div className="description">
                                <div className="left">
                                    <p>This two-hour training is for Java developers and architects who build high-performance and data-intensive applications that are powered by Apache Ignite. During the course, you are introduced to three of Ignite's essential capabilities (data partitioning, affinity co-location, and co-located processing) and learn how to apply your newly acquired knowledge to increase the speed and scale of your applications.</p>
                
                                    <h4>Training Topics:</h4>
                                    <ul>
                                        <li>The essential capabilities of Apache Ignite</li>
                                        <li>How to use data partitioning to achieve limitless horizontal scalability</li>
                                        <li>How affinity co-location of data makes it possible to run high-performance, distributed queries at scale</li>
                                        <li>How to run custom compute tasks straight on the cluster nodes, to negate any negative impact that a network might have on the performance of your applications.</li>
                                    </ul>

                                    <div className="cta"><a href="https://www.gridgain.com/training/register/apache-ignite-essentials-design-principles-building-data-intensive-11" target="_blank" rel="noreferrer" className="button past">Learn more</a></div>
                                </div>
                                <div className="right">
                                    <div className="img-wrapper"><StaticImage alt="Ian picture" src="../images/training-instructors/ian.jpeg"  /></div>
                                    <div className="trainer">
                                        <h4>Feb. 24 14:00 PM GMT / 9:00 AM EST</h4>
                                        <div>Ian Ruffell</div>
                                        <div>Solutions Architect at GridGain</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>

                    <article className="training-session" id="apache-ignite-spring-boot" >
                        <div className="container" >
                            <header>
                                <div className="txt-wrapper">
                                    <h2>Apache Ignite for Spring Boot and Spring Data Development</h2>
                                    <h4>Feb. 24 16:00 PM GMT / 11:00 AM EST</h4>
                                </div>
                            </header>
                            <div className="description">
                                <div className="left">
                                    <p>This two-hour training is for Java developers and architects who build high-performance and data-intensive applications that are powered by Apache Ignite. During the course, you are introduced to three of Ignite's essential capabilities (data partitioning, affinity co-location, and co-located processing) and learn how to apply your newly acquired knowledge to increase the speed and scale of your applications.</p>
                
                                    <h4>Training Topics:</h4>
                                    <ul>
                                        <li>Configuring an Apache Ignite cluster that uses Spring Boot and Spring Data</li>
                                        <li>Designing Java POJOs for Ignite Spring Data repositories</li>
                                        <li>Defining custom SQL queries for Ignite Spring Data repositories</li>
                                        <li>Designing DTOs (data transfer objects) for Ignite Spring Data services</li>
                                        <li>Building a Spring Boot RESTful endpoint that works with Ignite Spring Data services</li>
                                        <li>Learning tips and tricks while working with Ignite Spring Data and Ignite Spring Boot</li>
                                    </ul>

                                    <div className="cta"><a href="https://www.gridgain.com/training/register/apache-ignite-spring-boot-and-spring-data-development-2" target="_blank" rel="noreferrer" className="button past">Learn more</a></div>
                                </div>
                                <div className="right">
                                    <div className="img-wrapper"><StaticImage alt="Scott picture" src="../images/training-instructors/scott.jpg"  /></div>
                                    <div className="trainer">
                                        <h4>Feb. 24 16:00 PM GMT / 11:00 AM EST</h4>
                                        <div>Scott Stokes</div>
                                        <div>Solutions Architect at GridGain</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>

                    <article className="training-session" id="apache-ignite-design-principles" >
                        <div className="container" >
                            <header>
                                <div className="txt-wrapper">
                                    <h2>Apache Ignite Essentials: Design Principles for Building Data-Intensive Applications</h2>
                                    <h4>Feb. 24 13:00 PM EST / 10:00 AM PT</h4>
                                </div>
                            </header>
                            <div className="description">
                                <div className="left">
                                    <p>This two-hour training is for Java developers and architects who build high-performance and data-intensive applications that are powered by Apache Ignite. During the course, you are introduced to three of Ignite's essential capabilities (data partitioning, affinity co-location, and co-located processing) and learn how to apply your newly acquired knowledge to increase the speed and scale of your applications.</p>
                
                                    <h4>Training Topics:</h4>
                                    <ul>
                                        <li>The essential capabilities of Apache Ignite</li>
                                        <li>How to use data partitioning to achieve limitless horizontal scalability</li>
                                        <li>How affinity co-location of data makes it possible to run high-performance, distributed queries at scale</li>
                                        <li>How to run custom compute tasks straight on the cluster nodes, to negate any negative impact that a network might have on the performance of your applications.</li>
                                    </ul>

                                    <div className="cta"><a href="https://www.gridgain.com/training/register/apache-ignite-essentials-design-principles-building-data-intensive-10" target="_blank" rel="noreferrer" className="button past">Learn more</a></div>
                                </div>
                                <div className="right">
                                    <div className="img-wrapper"><StaticImage alt="Jeremy picture" src="../images/training-instructors/jeremy-mcmillan.png"  /></div>
                                    <div className="trainer">
                                        <h4>Feb. 24 13:00 PM EST / 10:00 AM PT</h4>
                                        <div>Jeremy McMillan</div>
                                        <div>Senior Consultant at GridGain</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                </div>
        </Layout>
        
    )
}

export default training
